export default "__VITE_ASSET__DGi9MwOj__"